import { useEffect, useId } from 'react';

export function ImageLightbox({
  open,
  src,
  alt,
  title,
  onClose,
}: {
  open: boolean;
  src: string;
  alt: string;
  title?: string;
  onClose: () => void;
}) {
  const titleId = useId();

  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    window.addEventListener('keydown', onKey);
    return () => {
      document.body.style.overflow = prev;
      window.removeEventListener('keydown', onKey);
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className="lightbox"
      role="dialog"
      aria-modal="true"
      aria-labelledby={title ? titleId : undefined}
      aria-label={title ? undefined : alt}
      onClick={onClose}
    >
      <button type="button" className="lightbox-close" onClick={onClose} aria-label="Close">
        ×
      </button>
      <div
        className="lightbox-panel"
        onClick={(e) => e.stopPropagation()}
      >
        <img src={src} alt={alt} className="lightbox-img" />
        {title ? (
          <p id={titleId} className="lightbox-caption">
            {title}
          </p>
        ) : null}
      </div>
    </div>
  );
}
